function getMinutes(timeStr: string): number {
  const match = timeStr.match(/^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9]))?$/);
  if (!match) {
    throw new Error(`Неверный формат времени: ${timeStr}. Ожидается "ЧЧ:ММ" или "ЧЧ:ММ:СС"`);
  }

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);

  return hours * 60 + minutes;
}

export { getMinutes };